<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editResource') }}</h1>
      <div class="form-container">
        <ResourceForm :data="relations.instance" @save="save"></ResourceForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import ResourceForm from "@/components/ResourceForm"

  export default {
    components: {
      ResourceForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'resources', payload}).then(() =>
          this.$router.push({ name: 'manageResources'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'resources', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'manageResources', path: 'manageResources'},
          {name: 'editResource'}
        ]
      }
    }
  }
</script>